import { useQuery } from 'react-query';

import { useCurrentAddressInfo } from '@/hooks';
import { queryClient, request } from 'utils';

const NEW_FEEDS_COUNT_INTERVAL = 10 * 1000;

type FeedNewCountRes = {
  has_new: boolean;
  count: number;
};

const select = (res: FeedNewCountRes) => {
  return res.count;
};
export const FEED_NEW_COUNT_URL = '/feed/new_count';
export const useNewStreamsCount = (
  create_at?: number,
  refetchInterval = NEW_FEEDS_COUNT_INTERVAL,
) => {
  const url = FEED_NEW_COUNT_URL;
  const { address, isVerified } = useCurrentAddressInfo();

  const query = useQuery(
    [url, address, create_at],
    () =>
      request.get<FeedNewCountRes>(url, {
        create_at: create_at!,
      }),
    {
      select,
      enabled: !!create_at && !!isVerified,
      refetchInterval,
      refetchOnWindowFocus: true,
      cacheTime: NEW_FEEDS_COUNT_INTERVAL,
      staleTime: NEW_FEEDS_COUNT_INTERVAL,
    },
  );

  return query;
};

export const RECOMMEND_FEED_NEW_COUNT_URL = '/feed/new_recommed_count';
export const NEW_RECOMMEND_FEED_INTERVAL = 10 * 60 * 1000;
export const useNewRecommendStreamsCount = ({
  create_at,
  enabled,
}: {
  create_at: number;
  enabled: boolean;
}) => {
  const url = RECOMMEND_FEED_NEW_COUNT_URL;
  const { address, isVerified } = useCurrentAddressInfo();

  const query = useQuery(
    [url, address, create_at],
    () =>
      request.get<FeedNewCountRes>(url, {
        create_at: create_at!,
      }),
    {
      select,
      enabled: !!create_at && !!isVerified && !!enabled,
      refetchInterval: NEW_RECOMMEND_FEED_INTERVAL,
      refetchOnWindowFocus: true,
      cacheTime: NEW_RECOMMEND_FEED_INTERVAL,
      staleTime: NEW_RECOMMEND_FEED_INTERVAL,
    },
  );

  return query;
};

const LastFeedReadURL = '/feed/last_is_read';

// 最新一条 feed 是否没读过
export const useIsLastFeedUnRead = () => {
  const { address, isVerified } = useCurrentAddressInfo();

  const query = useQuery(
    [LastFeedReadURL, address],
    () => request.get<{ is_read: boolean; article_id: number }>(LastFeedReadURL),
    {
      refetchInterval: NEW_FEEDS_COUNT_INTERVAL,
      refetchOnWindowFocus: true,
      enabled: !!address && isVerified,
      cacheTime: NEW_FEEDS_COUNT_INTERVAL,
      staleTime: NEW_FEEDS_COUNT_INTERVAL,
    },
  );

  return query;
};

export const invalidLastFeedRead = () => {
  queryClient.invalidateQueries([LastFeedReadURL]);
};
